import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { AssignDriversComponent } from './assign-drivers/assign-drivers.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { PaginatorModule } from '../shared/components/paginator/paginator.module';
import { SearchModule } from '../shared/components/search/search.module';
import { MatSelectModule } from '@angular/material/select';
import { AddAttributeValueComponent } from './add-attributeValue/add-attributeValue.component';
import { AddTeamComponent } from './add-team/add-team.component';
import { AddDriverDocumentComponent } from './add-driver-document/add-driver-document.component';
import { AddWalkthroughComponent } from './add-walkthrough/add-walkthrough.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { OtpComponent } from './otp/otp.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RejectionReasonComponent } from './rejection-reason/rejection-reason.component';
import { OrderCancelConfirmComponent } from './order-cancel-confirm/order-cancel-confirm.component';
import { AfterLoginSharedModule } from '../shared/after-login.shared.module';
import { TeamListComponent } from './team-list/team-list.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ExpectedDeliveryDateComponent } from './expected-delivery-date/expected-delivery-date.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { CommissionHandlingComponent } from './commission-handling/commission-handling.component';
import { SharedModule } from '../shared/shared.module';
import { PipesModule } from '../shared/pipes/pipes.module';
import { AddareaComponent } from './addarea/addarea.component';
import { AssignAreaComponent } from './assign-area/assign-area.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ViewImageComponent } from './view-image/view-image.component';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { FiltersComponent } from './filters/filters.component';
import { DriverApprovalComponent } from './driver-approval/driver-approval.component';
import { DeliveryChargesComponent } from './delivery-charges/delivery-charges.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { PrintBarcodeModalComponent } from './print-barcode-modal/print-barcode-modal.component';
import { AddressDetailsComponent } from './address-details/address-details.component';
import { OrderAmountDetailsComponent } from './order-amount-details/order-amount-details.component';
import { SubmitDriverCashComponent } from './submit-driver-cash/submit-driver-cash.component';
import { ViewRackComponent } from './view-rack/view-rack.component';
import { AssignBrandComponent } from './assign-brand/assign-brand.component';
import { AssignVendorComponent } from './assign-vendor/assign-vendor.component';
import { MultiColumnSelectComponent } from '../shared/components/multi-column-select/multi-column-select.component';
import { DriverTrackingComponent } from './driver-tracking/driver-tracking.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatTabsModule } from '@angular/material/tabs';
import { UserTopupComponent } from './user-topup/user-topup.component';
import { SubstituteProductsComponent } from './substitute-products/substitute-products.component';

@NgModule({
  declarations: [
    AssignDriversComponent,
    AddAttributeValueComponent,
    AddTeamComponent,
    AddDriverDocumentComponent,
    AddWalkthroughComponent,
    OtpComponent,
    RejectionReasonComponent,
    OrderCancelConfirmComponent,
    TeamListComponent,
    ExpectedDeliveryDateComponent,
    CommissionHandlingComponent,
    AddareaComponent,
    ViewImageComponent,
    AssignAreaComponent,
    OrderDetailsComponent,
    FiltersComponent,
    DriverApprovalComponent,
    DeliveryChargesComponent,
    PrintBarcodeModalComponent,
    AddressDetailsComponent,
    OrderAmountDetailsComponent,
    SubmitDriverCashComponent,
    ViewRackComponent,
    AssignBrandComponent,
    AssignVendorComponent,
    DriverTrackingComponent,
    UserTopupComponent,
    SubstituteProductsComponent
  ],
  imports: [
    CommonModule,
    MatDatepickerModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatIconModule,
    MatNativeDateModule,
    PaginatorModule,
    SearchModule,
    MatSelectModule,
    NgOtpInputModule,
    MatDialogModule,
    ReactiveFormsModule,
    TranslateModule,
    FormsModule,
    AfterLoginSharedModule,
    MatFormFieldModule,
    MatInputModule,
    SharedModule,
    PipesModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatButtonModule,
    MultiColumnSelectComponent,
    GoogleMapsModule,
    MatTabsModule
  ],
  exports: [RejectionReasonComponent, ExpectedDeliveryDateComponent, OrderCancelConfirmComponent]
})
export class ModalsModule {}
